// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var Scalars = require("../../scalars/Scalars.bs.js");
var RelayEnv = require("../../RelayEnv.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReasonPromise = require("../../reason/ReasonPromise.bs.js");
var Utils__Promise = require("../../utils/Utils__Promise.bs.js");
var InputWithPrefix = require("../common/Components/InputWithPrefix.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var Formality__Debouncer = require("../../vendor/re-formality/Formality__Debouncer.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var AgentMarketingProfileSlugFormQuery_graphql = require("../../__generated__/AgentMarketingProfileSlugFormQuery_graphql.bs.js");
var AgentMarketingProfileSlugFormMutation_graphql = require("../../__generated__/AgentMarketingProfileSlugFormMutation_graphql.bs.js");
var AgentMarketingProfileSlugFormValidationQuery_graphql = require("../../__generated__/AgentMarketingProfileSlugFormValidationQuery_graphql.bs.js");
var AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.bs.js");

var convertVariables = AgentMarketingProfileSlugFormValidationQuery_graphql.Internal.convertVariables;

var convertResponse = AgentMarketingProfileSlugFormValidationQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = AgentMarketingProfileSlugFormValidationQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, AgentMarketingProfileSlugFormValidationQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertVariables);

var ValidationQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

var convertVariables$1 = AgentMarketingProfileSlugFormMutation_graphql.Internal.convertVariables;

var convertResponse$1 = AgentMarketingProfileSlugFormMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = AgentMarketingProfileSlugFormMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, AgentMarketingProfileSlugFormMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, AgentMarketingProfileSlugFormMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$1
};

var validators = {
  slug: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: (function (param) {
        var slug = param.slug;
        if (slug === "") {
          return {
                  TAG: "Error",
                  _0: "IsRequired"
                };
        } else {
          return {
                  TAG: "Ok",
                  _0: slug
                };
        }
      }),
    validateAsync: Formality__Debouncer.make(700, (function (param) {
            var dispatch = param[1];
            var value = param[0];
            var validate = function (slug) {
              return Utils__Promise.toJsPromise(ReasonPromise.map(ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
                                          slug: slug
                                        }, undefined, undefined)), (function (v) {
                                    if (v.TAG !== "Ok") {
                                      return {
                                              TAG: "Error",
                                              _0: "GenericError"
                                            };
                                    }
                                    var result = v._0.marketingProfileSlugAvailability;
                                    if (result === undefined) {
                                      return {
                                              TAG: "Error",
                                              _0: "GenericError"
                                            };
                                    }
                                    switch (result.__typename) {
                                      case "SlugAvailable" :
                                          return {
                                                  TAG: "Ok",
                                                  _0: result.slug
                                                };
                                      case "SlugInvalid" :
                                          return {
                                                  TAG: "Error",
                                                  _0: {
                                                    TAG: "SlugInvalid",
                                                    suggestedSlug: result.suggestedSlug
                                                  }
                                                };
                                      case "SlugUnavailable" :
                                          return {
                                                  TAG: "Error",
                                                  _0: "SlugUnavailable"
                                                };
                                      case "__unselected" :
                                          return {
                                                  TAG: "Error",
                                                  _0: "GenericError"
                                                };
                                      
                                    }
                                  })), (function (e) {
                                return {
                                        TAG: "Ok",
                                        _0: e
                                      };
                              })));
            };
            Formality.Async.validateAsync(value, validate, (function (res) {
                    dispatch({
                          TAG: "ApplyAsyncResultForSlugField",
                          _0: value,
                          _1: res
                        });
                  }));
          })),
    eq: (function (prim0, prim1) {
        return prim0 === prim1;
      })
  }
};

function initialFieldsStatuses(_input) {
  return {
          slug: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            slug: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var value = fieldsStatuses.slug;
  var match;
  match = typeof value !== "object" ? ({
        NAME: "Result",
        VAL: validators.slug.validate(input)
      }) : (
      value.TAG === "Dirty" ? ({
            NAME: "Result",
            VAL: value._0
          }) : ({
            NAME: "Validating",
            VAL: value._0
          })
    );
  if (match.NAME !== "Result") {
    return {
            TAG: "Validating",
            fieldsStatuses: {
              slug: match.NAME === "Result" ? ({
                    TAG: "Dirty",
                    _0: match.VAL,
                    _1: "Shown"
                  }) : ({
                    TAG: "Validating",
                    _0: match.VAL
                  })
            },
            collectionsStatuses: undefined
          };
  }
  var slugResult = match.VAL;
  if (slugResult.TAG === "Ok") {
    return {
            TAG: "Valid",
            output: {
              slug: slugResult._0
            },
            fieldsStatuses: {
              slug: {
                TAG: "Dirty",
                _0: slugResult,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  } else {
    return {
            TAG: "Invalid",
            fieldsStatuses: {
              slug: {
                TAG: "Dirty",
                _0: slugResult,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  }
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurSlugField" :
                  var result = Formality.Async.validateFieldOfStringTypeOnBlur(state.input, state.fieldsStatuses.slug, validators.slug, (function (status) {
                          return {
                                  slug: status
                                };
                        }));
                  if (result === undefined) {
                    return "NoUpdate";
                  }
                  var value = result.slug;
                  if (typeof value === "object" && value.TAG !== "Dirty") {
                    var value$1 = value._0;
                    return {
                            TAG: "UpdateWithSideEffects",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                validators.slug.validateAsync([
                                      value$1,
                                      param.dispatch
                                    ]);
                              })
                          };
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: result,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
                  break;
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  switch (match$1.TAG) {
                    case "Valid" :
                        var output = match$1.output;
                        var error = state.formStatus;
                        var tmp;
                        tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Caml_option.some(error._0);
                        return {
                                TAG: "UpdateWithSideEffects",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: {
                                    TAG: "Submitting",
                                    _0: tmp
                                  },
                                  submissionStatus: "AttemptedToSubmit"
                                },
                                _1: (function (param) {
                                    var dispatch = param.dispatch;
                                    onSubmit(output, {
                                          notifyOnSuccess: (function (input) {
                                              dispatch({
                                                    TAG: "SetSubmittedStatus",
                                                    _0: input
                                                  });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              dispatch({
                                                    TAG: "SetSubmissionFailedStatus",
                                                    _0: error
                                                  });
                                            }),
                                          reset: (function () {
                                              dispatch("Reset");
                                            }),
                                          dismissSubmissionResult: (function () {
                                              dispatch("DismissSubmissionResult");
                                            })
                                        });
                                  })
                              };
                    case "Invalid" :
                        return {
                                TAG: "Update",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: "Editing",
                                  submissionStatus: "AttemptedToSubmit"
                                }
                              };
                    case "Validating" :
                        return {
                                TAG: "Update",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: state.formStatus,
                                  submissionStatus: state.submissionStatus
                                }
                              };
                    
                  }
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateSlugField" :
                  var nextInput = action._0(state.input);
                  var nextFieldsStatuses = Formality.Async.validateFieldOfStringTypeOnChangeInOnChangeMode(nextInput, state.fieldsStatuses.slug, state.submissionStatus, validators.slug, (function (status) {
                          return {
                                  slug: status
                                };
                        }));
                  var value$2 = nextFieldsStatuses.slug;
                  if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
                    var value$3 = value$2._0;
                    return {
                            TAG: "UpdateWithSideEffects",
                            _0: {
                              input: nextInput,
                              fieldsStatuses: nextFieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                validators.slug.validateAsync([
                                      value$3,
                                      param.dispatch
                                    ]);
                              })
                          };
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: nextFieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "ApplyAsyncResultForSlugField" :
                  var validator = validators.slug;
                  var x = state.fieldsStatuses.slug;
                  if (typeof x !== "object" || x.TAG === "Dirty" || !validator.eq(x._0, action._0)) {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                slug: {
                                  TAG: "Dirty",
                                  _0: action._1,
                                  _1: "Shown"
                                }
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                slug: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                slug: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: Caml_option.some(map(Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateSlug: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateSlugField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurSlug: (function () {
              dispatch("BlurSlugField");
            }),
          slugResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.slug),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.slug;
              if (typeof tmp !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              switch (match.TAG) {
                case "Valid" :
                    return true;
                case "Invalid" :
                    return false;
                case "Validating" :
                    return ;
                
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var Config = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertFragment = AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$2,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "text-tan-error-500 font-medium"
            });
}

var $$Error = {
  make: AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error
};

function AgentMarketingProfileSlugForm$Form$SlugValidationMessage(props) {
  var result = props.result;
  if (result === undefined) {
    return null;
  }
  var updateSlug = props.updateSlug;
  if (result.TAG === "Validating") {
    return null;
  }
  var match = result._0;
  if (match.TAG === "Ok") {
    return JsxRuntime.jsx("div", {
                children: "This URL is available",
                className: "text-green-700 font-medium"
              });
  }
  var match$1 = match._0;
  if (typeof match$1 !== "object") {
    switch (match$1) {
      case "SlugUnavailable" :
          return JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error, {
                      children: "This URL has already been taken"
                    });
      case "GenericError" :
          return JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error, {
                      children: "We're having problems validating your URL. Please try again later."
                    });
      case "IsRequired" :
          return JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error, {
                      children: "Is required"
                    });
      
    }
  } else {
    var suggestedSlug = match$1.suggestedSlug;
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error, {
                        children: "This URL contains invalid characters."
                      }),
                  suggestedSlug !== undefined ? JsxRuntime.jsxs("div", {
                          children: [
                            "How about ",
                            JsxRuntime.jsx("button", {
                                  children: suggestedSlug,
                                  className: "text-tan-blue-500 font-medium underline",
                                  onClick: (function (param) {
                                      updateSlug(suggestedSlug);
                                    })
                                }),
                            "?"
                          ]
                        }) : null
                ],
                className: "space-y-1"
              });
  }
}

var SlugValidationMessage = {
  $$Error: $$Error,
  make: AgentMarketingProfileSlugForm$Form$SlugValidationMessage
};

function makeUrlPrefix(url) {
  var baseUrl = Scalars.$$URL.toWebapiUrl(url);
  return baseUrl.host + baseUrl.pathname + "/";
}

function AgentMarketingProfileSlugForm$Form$SlugField(props) {
  var result = props.result;
  var status = Core__Option.map(result, (function (result) {
          if (result.TAG === "Validating") {
            return "validating";
          } else if (result._0.TAG === "Ok") {
            return "ok";
          } else {
            return "error";
          }
        }));
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Label.make, {
                            labelText: "Personalize the URL for your profile"
                          }),
                      className: "pt-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(InputWithPrefix.make, {
                              value: props.value,
                              onChange: props.onChange,
                              onBlur: props.onBlur,
                              prefix: makeUrlPrefix(props.baseUrl),
                              status: status
                            }),
                        JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage, {
                              result: result,
                              updateSlug: props.updateSlug
                            })
                      ],
                      className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-lg space-y-1"
                    })
              ],
              className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 pb-6 sm:py-6"
            });
}

var SlugField = {
  makeUrlPrefix: makeUrlPrefix,
  make: AgentMarketingProfileSlugForm$Form$SlugField
};

function AgentMarketingProfileSlugForm$Form(props) {
  var marketingProfile = use$2(props.marketingProfile);
  var match = use$1();
  var mutate = match[0];
  var form = useForm({
        slug: marketingProfile.urlDetails.slug
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          mutate({
                input: {
                  slug: param.slug
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var result = param.updateAgentMarketingProfileSlug;
                  if (result !== undefined && result.__typename === "AgentMarketingProfileSlugUpdated") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure();
                  }
                }), (function (param) {
                  notifyOnFailure();
                }), undefined);
        }));
  var onInputChanged = React.useCallback((function () {
          var match = form.status;
          if (typeof match !== "object") {
            if (match === "Editing") {
              return ;
            } else {
              return form.dismissSubmissionResult();
            }
          } else if (match.TAG === "Submitting") {
            return ;
          } else {
            return form.dismissSubmissionResult();
          }
        }), [form.status]);
  React.useEffect((function () {
          onInputChanged();
        }), [form.input]);
  var match$1 = form.status;
  var tmp;
  tmp = typeof match$1 !== "object" ? (
      match$1 === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
              title: "Your account was updated"
            })
    ) : (
      match$1.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Alert.$$Error.make, {
                    title: "There was an error updating your account. Please try again"
                  }),
              className: "mt-4"
            })
    );
  return JsxRuntime.jsx("form", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugField, {
                            onChange: (function ($$event) {
                                form.updateSlug((function (_input, value) {
                                        return {
                                                slug: value
                                              };
                                      }), $$event.target.value);
                              }),
                            value: form.input.slug,
                            onBlur: (function (param) {
                                form.blurSlug();
                              }),
                            result: form.slugResult,
                            updateSlug: (function (x) {
                                form.updateSlug((function (_input, value) {
                                        return {
                                                slug: value
                                              };
                                      }), x);
                              }),
                            baseUrl: marketingProfile.urlDetails.baseUrl
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                          href: Scalars.$$URL.toString(marketingProfile.publicUrl),
                                          target: "_blank",
                                          children: "View Profile"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                                  disabled: form.submitting,
                                                  children: "Save changes"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: tmp,
                                                  role: "status"
                                                })
                                          ],
                                          className: "flex flex-col items-end gap-3"
                                        })
                                  ],
                                  className: "flex pt-4 justify-between items-baseline"
                                })
                          })
                    ],
                    className: "flex flex-col divide-y"
                  }),
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  form.submit();
                })
            });
}

var Form = {
  ValidationQuery: ValidationQuery,
  Mutation: Mutation,
  Config: Config,
  Fragment: Fragment,
  SlugValidationMessage: SlugValidationMessage,
  SlugField: SlugField,
  make: AgentMarketingProfileSlugForm$Form
};

function AgentMarketingProfileSlugForm$Header(props) {
  var displayName = MarketingProfileSubpages.Page.Agent.useDisplayName();
  var breadcrumbs = [
    {
      name: "Marketing Profile",
      href: "/account/marketing_profile"
    },
    {
      name: displayName("Url"),
      href: MarketingProfileSubpages.Page.Agent.path("Url")
    }
  ];
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsx(Breadcrumbs.make, {
                      pages: breadcrumbs
                    }),
                JsxRuntime.jsx("h2", {
                      children: displayName("Url"),
                      className: "text-zinc-800 text-3xl font-medium"
                    })
              ],
              className: "space-y-3 border-b pb-2"
            });
}

var Header = {
  make: AgentMarketingProfileSlugForm$Header
};

var convertVariables$2 = AgentMarketingProfileSlugFormQuery_graphql.Internal.convertVariables;

var convertResponse$2 = AgentMarketingProfileSlugFormQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse$2 = AgentMarketingProfileSlugFormQuery_graphql.Internal.convertWrapRawResponse;

var use$3 = RescriptRelay_Query.useQuery(convertVariables$2, AgentMarketingProfileSlugFormQuery_graphql.node, convertResponse$2);

var useLoader$1 = RescriptRelay_Query.useLoader(convertVariables$2, AgentMarketingProfileSlugFormQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded$1 = RescriptRelay_Query.usePreloaded(AgentMarketingProfileSlugFormQuery_graphql.node, convertResponse$2, (function (prim) {
        return prim;
      }));

var $$fetch$1 = RescriptRelay_Query.$$fetch(AgentMarketingProfileSlugFormQuery_graphql.node, convertResponse$2, convertVariables$2);

var fetchPromised$1 = RescriptRelay_Query.fetchPromised(AgentMarketingProfileSlugFormQuery_graphql.node, convertResponse$2, convertVariables$2);

var retain$1 = RescriptRelay_Query.retain(AgentMarketingProfileSlugFormQuery_graphql.node, convertVariables$2);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  use: use$3,
  useLoader: useLoader$1,
  usePreloaded: usePreloaded$1,
  $$fetch: $$fetch$1,
  fetchPromised: fetchPromised$1,
  retain: retain$1
};

function AgentMarketingProfileSlugForm(props) {
  var match = use$3(undefined, "network-only", undefined, undefined);
  var marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "AgentMarketingProfile") {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(AgentMarketingProfileSlugForm$Header, {}),
                        JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form, {
                              marketingProfile: marketingProfile.fragmentRefs
                            })
                      ],
                      className: "space-y-8 sm:space-y-0"
                    }),
                className: "bg-white p-6 shadow-sm rounded space-y-8"
              });
  } else {
    return UnselectedUnionMemberError.raise("Unselected union member: " + marketingProfile._0);
  }
}

var make = AgentMarketingProfileSlugForm;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
